import { AccessTimeOutlined } from "@mui/icons-material";
import { Skeleton, Stack, Typography } from "@mui/material";

import { parseStringToDate } from "~/modules/app/util/dateHelpers";
import { formatTimeRange } from "~/modules/app/util/formatters";

type VisitTimeSlotProps = {
    startTime: string;
    endTime: string;
};

export function VisitTimeslot({ startTime, endTime }: VisitTimeSlotProps) {
    return (
        <Stack direction="row" padding={2} columnGap={1} alignItems="center">
            <AccessTimeOutlined />
            <Typography>{formatTimeRange(parseStringToDate(startTime), parseStringToDate(endTime))}</Typography>
            <Typography color="textSecondary" variant="caption">
                (excluding travel time)
            </Typography>
        </Stack>
    );
}

export function VisitTimeslotSkeleton() {
    return (
        <Stack direction="row" padding={2} alignItems="center">
            <Skeleton variant="text" width={300} height={24} />
        </Stack>
    );
}
